import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';
import { type BlazeSchema } from '@blaze-shared/schema-domain';

import { type DefinitionMapper } from '../../../ai';
import { extractCommonFormFields } from '../../../ai/common/extract-common-form-fields';
import { type CanvasElementDefinition } from '../../../canvas-elements/element-definition';

import { type TagsDefinition } from './tags.definition';

export class TagsDefinitionMapper implements DefinitionMapper<'tags'> {
  readonly type = 'tags';

  extract(
    element: CanvasElementFrom<'tags'>,
    _schemas: Readonly<Record<string, BlazeSchema>>,
    _definition: CanvasElementDefinition<'tags'>,
  ): PartialDeep<TagsDefinition> {
    const { options, tags } = element.props.content;

    return {
      ...extractCommonFormFields(element),
      isReadOnly: options?.readonly,
      placeholder: tags?.placeholder,
    };
  }
}
